// 二次确认弹窗封装
function deleRows(type,prompt,title,icon,url,params,callback,callback1){
    var _this=window.Vue
    _this.$confirm(prompt, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal:false,
        type: icon,
        beforeClose:(action, instance, done)=>{
            done()
        }
    }).then(() => {
        if(type == "post"){
            _this.$api.post(url,params,res=>{
                callback(res)
                if(res.code){
                    if(res.code == 200){
                        _this.$message({
                            type: 'success',
                            duration:'1000',
                            message:'操作成功 ！'
                        });
                    }else{
                        _this.$message({
                            type: 'error',
                            duration:'1000',
                            message:res.message
                        });
                    }
                }else{
                    _this.$message({
                        type: 'success',
                        duration:'1000',
                        message:'操作成功 ！'
                    });
                }
            })
        }else if(type=="put"){
            _this.$api.put(url,params,res=>{
                callback(res)
                if(res.code){
                    if(res.code == 200){
                        _this.$message({
                            type: 'success',
                            duration:'1000',
                            message:'操作成功 ！'
                        });
                    }else{
                        _this.$message({
                            type: 'error',
                            duration:'1000',
                            message:res.message
                        });
                    }
                }else{
                    _this.$message({
                        type: 'success',
                        duration:'1000',
                        message:'操作成功 ！'
                    });
                }
            })
        }else if(type=="delete"){
            _this.$api.delete(url,params,res=>{
                callback(res)
                if(res.code){
                    if(res.code == 200){
                        _this.$message({
                            type: 'success',
                            duration:'1000',
                            message:'操作成功 ！'
                        });
                    }else{
                        _this.$message({
                            type: 'error',
                            duration:'1000',
                            message:res.message
                        });
                    }
                }else{
                    _this.$message({
                        type: 'success',
                        duration:'1000',
                        message:'操作成功 ！'
                    });
                }
            })
        }else if(type=="get"){
            _this.$api.get(url,params,res=>{
                callback(res)
                if(res.code){
                    if(res.code==200){
                        _this.$message({
                            type: 'success',
                            duration:'1000',
                            message:'操作成功 ！'
                        });
                    }else{
                        _this.$message({
                            type: 'error',
                            duration:'1000',
                            message:res.message
                        });
                    }
                }else{
                    _this.$message({
                        type: 'success',
                        duration:'1000',
                        message:'操作成功 ！'
                    });
                }
            })
        }
    }).catch(() => {
        if(callback1){
            callback1()
        }
        _this.$message({
            type: 'info',
            duration:'1000',
            message: '已取消操作 ！'
        });
    });
}
export default {
    confirmation:function(type,prompt,title,icon,url,params,callback,callback1){
        return deleRows(type,prompt,title,icon,url,params,callback,callback1)
    }
}


// WEBPACK FOOTER //
// ./src/assets/script/confirm.js